import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { AnimationOptions, LottieComponent } from 'ngx-lottie';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'eb-technical-work-dialog',
  templateUrl: './technical-work-dialog.component.html',
  styleUrls: ['./technical-work-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, LottieComponent, TranslateModule],
})
export class TechnicalWorkDialogComponent {
  options: AnimationOptions = {
    path: '/assets/lottie/update.json',
  };

  reloadPage(): void {
    location.reload();
  }
}
